import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';

/**
 * ScrollIndicator Component
 * Displays a sleek scroll down animation at the bottom of the hero section
 * Works seamlessly in both light and dark modes
 */
const ScrollIndicator: React.FC = () => {
  return (
    <motion.div
      className="mt-20 flex flex-col items-center gap-2"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 1.5 }}
    >
      {/* Mouse/Scroll Icon */}
      <motion.div
        className="relative w-6 h-10 border-2 border-gray-400 dark:border-gray-500 rounded-full flex items-start justify-center p-2 transition-colors duration-300"
        animate={{
          opacity: [0.5, 1, 0.5],
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      >
        {/* Scroll Wheel */}
        <motion.div
          className="w-1 h-2 bg-gray-400 dark:bg-gray-500 rounded-full transition-colors duration-300"
          animate={{
            y: [0, 8, 0],
          }}
          transition={{
            duration: 1.5,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        />
      </motion.div>

      {/* Animated Chevrons */}
      <div className="flex flex-col -space-y-3">
        <motion.div
          animate={{
            y: [0, 4, 0],
            opacity: [0.3, 1, 0.3],
          }}
          transition={{
            duration: 1.5,
            repeat: Infinity,
            ease: "easeInOut",
            delay: 0
          }}
        >
          <ChevronDown className="w-4 h-4 text-gray-400 dark:text-gray-500 transition-colors duration-300" />
        </motion.div>
        <motion.div
          animate={{
            y: [0, 4, 0],
            opacity: [0.3, 1, 0.3],
          }}
          transition={{
            duration: 1.5,
            repeat: Infinity,
            ease: "easeInOut",
            delay: 0.2
          }}
        >
          <ChevronDown className="w-4 h-4 text-gray-400 dark:text-gray-500 transition-colors duration-300" />
        </motion.div>
      </div>
    </motion.div>
  );
};

export default ScrollIndicator;
